import { render, staticRenderFns } from "./ColorAttributeValue.vue?vue&type=template&id=fc840236"
import script from "./ColorAttributeValue.vue?vue&type=script&lang=ts"
export * from "./ColorAttributeValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports